// imports
import { JSX, PropsWithChildren } from 'react';

// styles
import styles from './PageTransition.module.scss';

const PageTransition = ({ children }: PropsWithChildren): JSX.Element => {
  return (
    <div className={styles.page_transition}>
      {children}
    </div>
  );
};

export default PageTransition;
